import PasswordChangeModal from "adminUsers/PasswordChangeModal";
import Ajax from "base/Ajax";
import FormValidator from "base/FormValidator";
import Message from "base/Message";
import Modal from "modal/Modal";

class AccountDetailsModal extends Modal {

    buildElement() {
        if (this.built) return;
        super.buildElement();

        let $form = eotwJSXFactory('form', {class: "admin-form"}, [
            eotwJSXFactory('h1', null, ["Account Settings"]),
            eotwJSXFactory('p', null, ["Update your account details below. Note that your email address is also the username you log in with."]),
            eotwJSXFactory('div', {class: "admin-form__row"}, [
                eotwJSXFactory('label', {class: "admin-form__label", for: "admin-user-name"}, ["Name"]),
                eotwJSXFactory('input', {class: "admin-form__input", id: "admin-user-name", name: "name", value: window.User.name}),
                eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
            ]),
            eotwJSXFactory('div', {class: "admin-form__row"}, [
                eotwJSXFactory('label', {class: "admin-form__label", for: "admin-user-company"}, ["Company"]),
                eotwJSXFactory('input', {class: "admin-form__input", id: "admin-user-company", name: "company", value: window.User.company, 'data-optional': true}),
                eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
            ]),
            eotwJSXFactory('div', {class: "admin-form__row"}, [
                eotwJSXFactory('label', {class: "admin-form__label", for: "admin-user-email"}, ["Email Address"]),
                eotwJSXFactory('input', {class: "admin-form__input", id: "admin-user-email", name: "email", value: window.User.email}),
                eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
            ]),

            eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal", type: "submit"}, ["Save"]),
                eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal js-cancel"}, ["Cancel"]),
                window.CONFIG.adminUsers.providers.password.enabled ? eotwJSXFactory('button', {class: "admin-btn admin-btn--modal js-update-password"}, ["Update Password"]) : undefined
            ])
        ]);

        FormValidator.attach($form, {inputOptions: {messages: {empty: "You must enter your {name}"}}}).on("submit", ($form) => {
            let $btn = $form.find("button[type='submit']");
            if ($btn.is(".admin-btn--loading")) return;
            $btn.addClass("admin-btn--loading");

            Ajax.post("adminUsers", "current", $form.serializeJSON()).then((data) => {
                window.User = data;
                this.destroy();
            }).catch((e) => {
                $btn.removeClass("admin-btn--loading");
                new Message(e.message, "Couldn't save your settings");
            });
        });

        this.setContent($form);

        this.on("click", ".js-cancel", () => {
            this.destroy();
            return false;
        }).on("click", ".js-update-password", () => {
            let passwordChangeModal = new PasswordChangeModal();
            passwordChangeModal.on("hide", () => {
                passwordChangeModal.destroy();
                this.show();
            });

            passwordChangeModal.show();
            return false;
        });


    }
}


export default AccountDetailsModal;
